<template>
  <!--页面的底部-->
  <div class="footer" v-if="footer">{{ footer }}</div>
</template>
<script>
import { getStorage } from '@/plugins/store'

export default {
  name: 'Footer',
  data() {
    return { footer: '' }
  },
  created() {
    this.getBaseSet()
  },
  methods: {
    async getBaseSet() {
      const res = getStorage('projectBaseData') || {}
      this.footer = res.copyright
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  height: 60px;
  width: 100%;
  text-align: center;
  line-height: 60px;
  background: #194189;
  color: #FFFFFF66;
  font-size: 12px;
  font-weight: 400;
}
</style>
